module.exports = __webpack_public_path__ + "img/mn.df1ca914.svg";